import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CatSearchForm } from '@blocks-react/components/SearchForm';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatLoadingIndicator } from '@blocks-react/components/LoadingIndicator';

const SearchFormWithLoader = ({
  children,
  searchTerm,
  isLoading,
  isResultEmpty,
  searchFormLabel,
  searchFormPlaceHolder,
  onChange,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <CatSearchForm
      label={searchFormLabel}
      onBlChange={e => onChange(e.detail.value)}
      value={searchTerm}
      placeholder={searchFormPlaceHolder}
      mobileBreakPoint={0}
      isEmpty={isResultEmpty}
      {...props}
    >
      {isLoading ? (
        <CatList shadow={'subtle'}>
          <CatListItem isStatic={true}>
            <div className="d-flex align-items-center">
              <CatLoadingIndicator small />
              <div className="ms-2">{t('SEARCHING')}</div>
            </div>
          </CatListItem>
        </CatList>
      ) : (
        children
      )}
    </CatSearchForm>
  );
};

export default SearchFormWithLoader;

SearchFormWithLoader.propTypes = {
  children: PropTypes.node,
  searchTerm: PropTypes.string,
  isLoading: PropTypes.bool,
  isResultEmpty: PropTypes.bool,
  searchFormLabel: PropTypes.string,
  searchFormPlaceHolder: PropTypes.string,
  onChange: PropTypes.func,
  props: PropTypes.shape({ autoFocus: PropTypes.bool })
};
